let embedController = () => {
    window.videojs = require('video.js');
    require('../modules/video-player-init').on();
    require('../modules/video-player-message-handler').on();
    require('../modules/video-player-unmute').on();
    require('../modules/video-player-modals').on();
};

export default embedController;
